import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config";


export default function ErrorComponent({error}) {
  const { instance: msalInstance } = useMsal();

    useEffect(() => {
        if (error && error.toString().includes('AADB2C90091')) {
            msalInstance.loginRedirect(loginRequest);
            return;
        }
    }, [error, msalInstance]);

    return <p>An Error Occurred: {typeof error !== "undefined" ? error.toString() : "Unknown error"}</p>;
}